import { all, takeEvery, put, call } from 'redux-saga/effects'
import { notification } from 'antd'
import { history } from 'index'
import { push } from 'react-router-redux'
// import { GET_DATA } from 'redux/menu/sagas'
import { getAllNotificationItems } from 'redux/notifications/saga'
import { GETPAYCONSTRUCTPRODUCTS } from 'redux/register/saga'
import method from 'utilities/apiCaller'

import generalActions from '../general/actions'
import { getAllCurrencies, getAllCountries } from '../general/saga'
import { getChatAccessToken } from '../chat/saga'

import actions from './actions'
import Variables from '../../utilities/variables'

const { urls } = Variables

const newUserRegistration = values => {
  return method.authPrivatePost('auth/signup', values).then(response => {
    return response.data.data
  })
}

export function* REGISTER(values) {
  const { payload } = values
  try {
    const response = yield call(newUserRegistration, payload)
    yield put({
      type: actions.REGISTER_SUCCESS,
      value: response,
    })
    if (response.access_token) {
      yield put({
        type: actions.GET_USER_DATA,
        values: response.access_token,
      })
    }
  } catch (err) {
    yield put({
      type: actions.REGISTER_FAILURE,
      payload: err,
    })
    notification.error({
      message: 'Warning',
      description: err.response.data.message,
    })
  }
}

const userLogin = values => {
  return method.authPrivatePost('auth/login', values).then(response => {
    return response.data.data
  })
}

export function* LOGIN(values) {
  const { payload } = values
  try {
    const response = yield call(userLogin, payload)
    yield put({
      type: actions.LOGIN_SUCCESS,
      value: response,
    })
    if (response.mfa_required) {
      history.push(urls.setUp2faUrl)
      yield put({
        type: actions.SETUP_MFA_AUTHENTICATOR,
        values: response,
      })
    }
    if (!response.mfa_required && response.isMFAset) {
      history.push(urls.codeValidatorUrl)
    }
    if (!response.mfa_required && response.access_token) {
      if (response) {
        yield put({
          type: actions.GET_USER_DATA,
          values: response.access_token,
        })
      }
    }
  } catch (err) {
    yield put({
      type: actions.LOGIN_FAILURE,
      payload: err,
    })
    notification.warning({
      message: 'Wrong Credientials',
      description: 'Login Failed, Try Again',
    })
  }
}

const resetPassword = values => {
  return method.authPrivatePost('auth/password/reset', values).then(response => {
    return response.data.data
  })
}

export function* RESETPASSWORD(values) {
  const { payload } = values
  try {
    const response = yield call(resetPassword, payload)
    yield put({
      type: actions.RESET_PASSWORD_SUCCESS,
      value: response,
    })
    notification.success({
      description: 'Email sent for reset password!',
    })
  } catch (err) {
    yield put({
      type: actions.RESET_PASSWORD_FAILURE,
      payload: err,
    })
  }
}

// is 2f enabled

const isMFAEnabled = value => {
  const values = {
    useMfa: value.isMFAEnable,
    authenticatorTypes: ['otp'],
  }
  return method.authPrivatePost('two-factor', values, value.userToken).then(response => {
    return response.data.data
  })
}

export function* ISMFAENABLED(value) {
  try {
    const response = yield call(isMFAEnabled, value.values)
    yield put({
      type: actions.IS_MFA_ENABLED_SUCCESS,
      value: response,
    })
    // const userState = yield select(state => state.user)
    // if (response) {
    //   yield put({
    //     type: actions.SETUP_MFA_AUTHENTICATOR,
    //     values: {
    //       mfa_token: userState.mfaToken,
    //     },
    //   })
    // }
  } catch (err) {
    yield put({
      type: actions.IS_MFA_ENABLED_FAILURE,
      payload: err,
    })
    notification.error({
      description: 'Something is wrong!',
    })
  }
}

const setup2FA = value => {
  const values = {
    authenticator_types: ['otp'],
    mfa_token: value.mfa_token,
  }
  return method.authPrivatePost('auth/setup-authenticator', values).then(response => {
    return response.data.data
  })
}

export function* SETUP2FA(value) {
  try {
    const response = yield call(setup2FA, value.values)
    yield put({
      type: actions.SETUP_MFA_AUTHENTICATOR_SUCCESS,
      value: response,
    })
  } catch (err) {
    yield put({
      type: actions.SETUP_MFA_AUTHENTICATOR_FAILURE,
      payload: err,
    })
    notification.error({
      description: 'Something is wrong!',
    })
  }
}

const initialValidateMFACode = values => {
  return method.authPrivatePost('auth/login/otp', values).then(response => {
    return response.data.data
  })
}

export function* INITIALVALIDATE2FACODE(values) {
  const { payload } = values
  try {
    const response = yield call(initialValidateMFACode, payload)
    yield put({
      type: actions.INITIAL_AUTHORIZE_2FA_CODE_SUCCESS,
      value: response,
    })
    if (response) {
      yield put({
        type: actions.GET_USER_DATA,
        values: response.access_token,
      })
    }
  } catch (err) {
    yield put({
      type: actions.INITIAL_AUTHORIZE_2FA_CODE_FAILURE,
      payload: err,
    })
  }
}

const validateMFACode = values => {
  return method.authPrivatePost('auth/login/otp', values).then(response => {
    return response.data.data
  })
}

export function* VALIDATE2FACODE(value) {
  try {
    const response = yield call(validateMFACode, value.values)
    // const userState = yield select(state => state.user)
    yield put({
      type: actions.AUTHORIZE_2FA_CODE_SUCCESS,
      value: response,
    })
    if (response) {
      yield put({
        type: actions.GET_USER_DATA,
        values: response.access_token,
      })
    }
  } catch (err) {
    yield put({
      type: actions.AUTHORIZE_2FA_CODE_FAILURE,
      payload: err,
    })
    notification.error({
      description: 'Something is wrong!',
    })
  }
}

const verifyMFACode = values => {
  return method.authPrivatePost('verify-otp', values).then(response => {
    return response.data.data
  })
}

export function* VERIFY2FACODE(value) {
  try {
    const response = yield call(verifyMFACode, value.values)
    yield put({
      type: actions.VERIFY_2FA_CODE_SUCCESS,
      value: response,
    })
    if (response) {
      notification.success({
        description: '2FA Setup Success!!',
      })
    }
  } catch (err) {
    yield put({
      type: actions.VERIFY_2FA_CODE_FAILURE,
      payload: err,
    })
  }
}

const getUserData = token => {
  return method.authPrivateGet(`profile`, token).then(response => {
    return response.data.data
  })
}

export function* GETUSERDATA(value) {
  try {
    const response = yield call(getUserData, value.values)
    yield put({
      type: actions.GET_USER_DATA_SUCCESS,
      value: response,
    })

    // new
    if (response) {
      yield put(push('/'))
      notification.success({
        message: 'Log-In',
        description: 'You`ve successfully logged in!',
      })
    }

    const chatValues = {
      clientEmail: response.email,
      userType: response.userType,
      token: value.values,
    }
    const clientValues = {
      entityId: response.entityId,
      token: value.values,
    }

    const parentId = response.entityId
    const token = value.values

    const payconstructDetails = {
      payload: {
        accessToken: value.values,
        productName: 'payconstruct',
      },
    }

    yield all([
      put({
        type: generalActions.GET_CLIENT_BY_ID,
        value: clientValues,
      }),
      put({
        type: generalActions.GET_CLIENT_PARTNER_BY_PARENT_ID,
        payload: { parentId, token },
      }),
      // call(GET_DATA),
      call(getChatAccessToken, { values: chatValues }),
      call(getAllCountries, { token: value.values }),
      call(getAllCurrencies, { token: value.values }),
      call(getAllNotificationItems, { email: response.email, token: value.values }),
      call(GETPAYCONSTRUCTPRODUCTS, payconstructDetails),
    ])

    // if (response.customer.isPreQualificationSetup && response.customer.isRiskQualificationSetup) {
    //   history.push('/')
    // }
  } catch (err) {
    yield put({
      type: actions.GET_USER_DATA_FAILURE,
      payload: err,
    })
    notification.error({
      description: 'Something is wrong!',
    })
  }
}

const updateUserData = (id, values, token) => {
  return method.authPrivatePut(`users/${id}`, values, token).then(response => {
    return response.data.data
  })
}

export function* UPDATEUSERDATA(values) {
  try {
    const response = yield call(updateUserData, values.userId, values.communications, values.token)
    yield put({
      type: actions.UPDATE_USER_DATA_SUCCESS,
      value: response,
    })
  } catch (err) {
    yield put({
      type: actions.UPDATE_USER_DATA_FAILURE,
      payload: err,
    })
  }
}

export function* AUTHORIZATION_APP() {
  const payload = true
  yield put({
    type: actions.AUTHORIZED_APP_SUCCESS,
    value: payload,
  })
}

const emailVerficiationLink = value => {
  const { emailId, tkn } = value
  const data = {}
  data.email = emailId
  return method.authPrivatePost('confirm-email', data, tkn).then(response => {
    return response.data.data
  })
}

export function* EMAILVERIFICATIONLINK(values) {
  const { payload } = values
  try {
    const response = yield call(emailVerficiationLink, payload)
    yield put({
      type: actions.SEND_EMAIL_CONFIRM_LINK_SUCCESS,
      value: response,
    })
    notification.success({
      description: 'Sent another email link to you email!',
    })
  } catch (err) {
    yield put({
      type: actions.SEND_EMAIL_CONFIRM_LINK_FAILURE,
      payload: err,
    })
  }
}

const getUsersByClient = (clientId, token) => {
  return method.authPrivateGet(`authenticate/user?clientId=${clientId}`, token).then(response => {
    return response.data.data
  })
}

export function* getClientUsers(values) {
  try {
    const response = yield call(getUsersByClient, values.clientId, values.token)
    yield put({
      type: actions.GET_USERS_BY_CLIENT_SUCCESS,
      value: response,
    })
  } catch (err) {
    yield put({
      type: actions.GET_USERS_BY_CLIENT_FAILURE,
      payload: err,
    })
  }
}

const getAgents = token => {
  return method.authPrivateGet('authenticate/user?userType=ops', token).then(response => {
    return response.data.data
  })
}

export function* getOpsUsers(values) {
  try {
    const response = yield call(getAgents, values.token)
    yield put({
      type: actions.GET_OPS_USERS_SUCCESS,
      value: response,
    })
  } catch (err) {
    yield put({
      type: actions.GET_OPS_USERS_FAILURE,
      payload: err,
    })
  }
}

const changeUserPassword = body => {
  return method.authPrivatePost('auth/password/change', body).then(response => {
    return response
  })
}

export function* changePassword(value) {
  try {
    const response = yield call(changeUserPassword, value.values)
    if (response) {
      notification.success({
        message: response.data.message,
      })
    }
    yield put({
      type: actions.CHANGE_PASSWORD_SUCCESS,
      value: response,
    })
  } catch (err) {
    yield put({
      type: actions.CHANGE_PASSWORD_FALIURE,
      payload: err.response.data.message,
    })
    notification.error({
      message: err.response.data.message,
    })
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.REGISTER, REGISTER),
    takeEvery(actions.LOGIN, LOGIN),

    takeEvery(actions.GET_USER_DATA, GETUSERDATA),
    takeEvery(actions.UPDATE_USER_DATA, UPDATEUSERDATA),
    takeEvery(actions.RESET_PASSWORD, RESETPASSWORD),
    takeEvery(actions.SEND_EMAIL_CONFIRM_LINK, EMAILVERIFICATIONLINK),
    takeEvery(actions.IS_MFA_ENABLED, ISMFAENABLED),
    takeEvery(actions.SETUP_MFA_AUTHENTICATOR, SETUP2FA),
    takeEvery(actions.INITIAL_AUTHORIZE_2FA_CODE, INITIALVALIDATE2FACODE),

    takeEvery(actions.AUTHORIZE_2FA_CODE, VALIDATE2FACODE),
    takeEvery(actions.VERIFY_2FA_CODE, VERIFY2FACODE),

    takeEvery(actions.GET_OPS_USERS, getOpsUsers),
    takeEvery(actions.GET_USERS_BY_CLIENT, getClientUsers),
    takeEvery(actions.CHANGE_PASSWORD, changePassword),
  ])
}
